import { render, staticRenderFns } from "./SupportResponse.vue?vue&type=template&id=72111c14&scoped=true&"
import script from "./SupportResponse.vue?vue&type=script&lang=js&"
export * from "./SupportResponse.vue?vue&type=script&lang=js&"
import style0 from "./SupportResponse.vue?vue&type=style&index=0&id=72111c14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72111c14",
  null
  
)

export default component.exports